import { ComponentAPI } from '@philips-emr/tws-core';
import { isEnumValid } from '@philips-emr/tws-utils';

import { LayoutAlign, LayoutJustify } from '../../constants';

class PanelAPI extends ComponentAPI {

  getAlignItems(): LayoutAlign {
    return this.state.alignItems;
  }

  setAlignItems(alignItems: LayoutAlign): void {
    if (isEnumValid(LayoutJustify, LayoutAlign)) {
      this.setState({ alignItems });
    }
  }

  getBackground(): string {
    return this.state.background;
  }

  setBackground(background: string): void {
    this.setState({ background });
  }

  getBorder(): string {
    return this.state.border;
  }

  setBorder(border: string): void {
    this.setState({ border });
  }

  getBorderRadius(): string {
    return this.state.borderRadius;
  }

  setBorderRadius(borderRadius: string): void {
    this.setState({ borderRadius });
  }

  getBoxShadow(): string {
    return this.state.boxShadow;
  }

  setBoxShadow(boxShadow: string): void {
    this.setState({ boxShadow });
  }

  getJustifyContent(): LayoutJustify {
    return this.state.justifyContent;
  }

  setJustifyContent(justifyContent: LayoutJustify): void {
    if (isEnumValid(LayoutJustify, justifyContent)) {
      this.setState({ justifyContent });
    }
  }

  isLightTheme(): boolean {
    return this.state.lightTheme;
  }

  setLightTheme(lightTheme: boolean): void {
    this.setState({ lightTheme });
  }

  getMargin(): string {
    return this.state.margin;
  }

  setMargin(margin: string): void {
    this.setState({ margin });
  }

  getPadding(): string {
    return this.state.padding;
  }

  setPadding(padding: string): void {
    this.setState({ padding });
  }

  isVisible(): boolean {
    return this.state.visible;
  }

  setVisible(visible: boolean): void {
    this.setState({ visible });
  }

}

export default PanelAPI;
